import './assets/main.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faArrowRight,
    faBars,
    faBuilding,
    faChartLine,
    faClipboardCheck,
    faCode,
    faCreditCard,
    faEnvelope,
    faFax,
    faFileLines,
    faGasPump,
    faLocationDot,
    faLock,
    faPhone,
    faTruck,
    faXmark
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import {
    faFacebook,
    faInstagram,
    faLinkedin,
    faTwitter,
    faXing
} from '@fortawesome/free-brands-svg-icons'

library.add(
    faBars,
    faXmark,
    faArrowRight,
    faFileLines,
    faTruck,
    faChartLine,
    faGasPump,
    faBuilding,
    faPhone,
    faFax,
    faEnvelope,
    faCreditCard,
    faClipboardCheck,
    faCode,
    faLock,
    faLocationDot,
    faLinkedin,
    faTwitter,
    faXing,
    faFacebook,
    faInstagram
)

import App from './App.vue'
import i18n, { initializeLocale } from './i18n'
import router from './router'
import ClientLogService from '@/services/clientLogService'

const clientLogService = new ClientLogService();

const app = createApp(App)

app.config.errorHandler = (err, vm, info) => {
    console.log(err);
    console.error("Error:", err);
    console.error("Vue component:", vm);
    console.error("Additional info:", info);
    clientLogService.create({
        file: info,
        message: JSON.stringify(err),
        url: window.location.href,
    });
};

app.use(createPinia())
app.use(router)
app.use(i18n)

// Initialisiere die Sprache
initializeLocale()

app.component('FontAwesomeIcon', FontAwesomeIcon)

app.mount('#app')
